export function find<T extends { customFieldId: string }>(
  ts: T[] | undefined,
  customFieldId: string
) {
  return ts?.find((t) => t.customFieldId === customFieldId)
}
